import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Fade, FormControl, FormControlLabel, FormGroup, Grid, Menu, MenuItem, Modal, Switch, TextField, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import CircularProgress from '@mui/material/CircularProgress';
import Toolbar from '@mui/material/Toolbar';
import { makeStyles } from '@mui/styles';
import { debounce } from 'lodash';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as AddSquareIcon } from "../../../assets/icons/icon-add-square.svg";
import { ReactComponent as MoreIcon } from "../../../assets/icons/icon-more.svg";
import { ReactComponent as RefreshIcon } from "../../../assets/icons/icon-refresh.svg";
import Controls from '../../controls/Controls';
import { deleteDashboard } from '../../../config/services/dashboards';
import { DecryptData } from "../../../utils/encryptDecrypt";
import { useDashboardContext } from '../../../layouts/dashboardView/DashboardView';
import { ReactComponent as TitleEditIcon } from "../../../assets/icons/icon-report-title-edit.svg";
import { ReactComponent as CopyAsNewIcon } from "../../../assets/icons/icon-report-copy-as-new-primary.svg";
import { ReactComponent as ExportIcon } from "../../../assets/icons/icon-report-export-primary.svg";
import { ReactComponent as DropdownIcon } from "../../../assets/icons/icon-angle-down.svg";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  title: {
    color: '#202124',
    fontSize: '22px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#202124',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  headingButton: {
    display: 'flex',
    marginRight: '16px',
    width: '100px',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start'
    },
  },
  headingButtonLg: {
    display: 'flex',
    marginRight: '16px',
    width: '120px',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start'
    },
    [theme.breakpoints.down('up')]: {
      width: '120px',
    },
  },
  headingIcon: {
    display: 'flex',
    width: '100px',
    '&:hover': {
      background: 'none',
    },
    [theme.breakpoints.down('lg')]: {
      marginRight: '2rem',
    },
  },
  reportHeader: {
    background: 'transparent',
    boxShadow: 'none',
    // borderBottom: '1px solid #DEDEDE',
  },
  button: {
    color: '#202124',
    fontWeight: 'normal',
    '&:hover': {
      background: 'none',
    },
    marginLeft: 0,
    paddingLeft: 0,
  },
  noBorder: {
    border: "none",
  },
  headingButtonWrap: {
    width: '90%',
    float: 'right',
    padding: '0 1rem',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#f45e29',
    },
    ['@media (max-width:1700px)']: {
      padding: '0 0.5rem',
      width: '95%',
      lineHeight: '16px',
      textAlign: 'center',
    },
    ['@media (max-width:1400px)']: {
      padding: '0.2rem 0.5rem',
      width: '100%',
      textAlign: 'center',
      lineHeight: '16px',
    },
    ['@media (max-width: 1199px)']: {
      float: 'left',
      maxWidth: '150px',
    }
  },
  headerButtons: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start'
    },
  },
  menuDropdownItem: {
    fontSize: '14px',
    color: '#202124',
    '&:hover': {
      backgroundColor: '#f6f6f6'
    }
  }
}));

export default function DashboardReportHeaderNew({
  onSaveLoader,
  onhandleSaveDashboard,
  handleSaveAsPopup,
  handlePublishDashboard,
  onOpenSidebar,
  handleDashboardExport,
  setRenewCache,
  renewCache,
  currentUserType,
  handleDashboardPreview,
}) {
  const { dashboardState, updateDashboard, addNewSheet } = useDashboardContext();
  const classes = useStyles();
  const UrlParams = useParams();
  const navigate = useNavigate();
  const currentRole = DecryptData(localStorage.getItem('role'))
  const [addMenuEl, setAddMenuEl] = useState(null);
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false);
  const openAddMenu = Boolean(addMenuEl);
  const [isDashboardTitleInEditMode, setIsDashboardTitleInEditMode] = useState(false);

  const handleAddMenuHover = (event) => {
    if (addMenuEl !== event.currentTarget) {
      setAddMenuEl(event.currentTarget);
    }
  };
  const handleAddMenuClose = () => {
    setAddMenuEl(null);
  };

  const [moreMenuEl, setMoreMenuEl] = React.useState(null);
  const openMoreMenu = Boolean(moreMenuEl);
  const handleMoreMenuHover = (event) => {
    if (moreMenuEl !== event.currentTarget) {
      setMoreMenuEl(event.currentTarget);
    }
  };
  const handleMoreMenuClose = () => {
    setMoreMenuEl(null);
  };

  const handleSelectDeleteDash = (type) => {
    switch (type) {
      case 'open':
        setConfirmDeleteDialog(true)
        break;
      case 'cancel':
        setConfirmDeleteDialog(false)
        break
    }
  }


  const submitDeleteDashboard = () => {
    let { id } = UrlParams
    if (id === 'new') {
      toast.error('Dashboard is not saved yet.')
    }
    else {
      deleteDashboard({ dashboardId: id })
        .then(resp => {
          if (resp?.message) {
            handleSelectDeleteDash('cancel')
            toast.success(resp?.message)
            navigate(`/dashboard`)
          }
          else if (!resp?.status?.statusCode) {
            toast.error(resp?.data?.error?.errorMessage)
          }
        })
    }
  }

  const handleDashboadResync = () => {
    let isResync = !renewCache
    setRenewCache(isResync)
  }

  const dashboardDetailsChange = debounce((e) => {
    updateDashboard({ [e.target.name]: e.target.value });
  }, 400);

  function tabDesignChange(e) {
    const value = e.target.checked ? 'new' : 'old';
    if (dashboardState?.tabDesign !== value) {
      updateDashboard({ tabDesign: value });
    }
  }

  function notificationBannerChange(e) {
    updateDashboard({ notificationBanner: dashboardState?.notificationBanner ? false : true });
  }

  return (
    <div className={classes.grow}>
      <AppBar className={classes.reportHeader} position="relative">
        <Toolbar className="p-0">

          <Grid container mb={2} className="report-new-header-container" justifyContent="space-between" >
            <Grid container item alignItems="start" justifyContent="center" direction="column" mb={2}
              sm={12} md={12} lg={5} order={{ lg: 1, md: 2, sm: 2, xs: 2 }} sx={{ mb: 1 }} >
                {
                  isDashboardTitleInEditMode
                    ? <>
                        <FormControl sx={{ marginBottom: '1rem' }}>
                          <TextField
                            size="small"
                            variant="standard"
                            name="dashboardName"
                            defaultValue={dashboardState.dashboardName}
                            placeholder="Dashboard Name"
                            onChange={dashboardDetailsChange}
                            className="re-edit-header-input main-title"
                            autoComplete={'off'}
                          />
                        </FormControl>
                        <FormControl
                          fullWidth
                          className={classes.margin}
                        >
                          <TextField
                            size="small"
                            variant="standard"
                            name='dashboardDescription'
                            defaultValue={dashboardState.dashboardDescription}
                            placeholder="Add Description"
                            onChange={dashboardDetailsChange}
                            className="re-edit-header-input sub-title" 
                            autoComplete={'off'}
                          />
                        </FormControl>
                      </>

                    : <>
                        <Box className="re-edit-header-in-edit-mode">
                            <Box className="re-edit-header-title"><span>{dashboardState?.dashboardName || 'Dashboard Name'}</span> <TitleEditIcon onClick={() => setIsDashboardTitleInEditMode(true)} className="re-anchor" /></Box>
                            <Box className="re-edit-header-subtitle">{dashboardState?.dashboardDescription || 'Description about the dashboard.'}</Box>
                        </Box>
                      </>
                }
              
            </Grid>

            <Grid className="report-header-action-items" container item mb={2} spacing={0} alignItems="center" justifyContent="flex-end"
              sm={12} md={12} lg={7} order={{ lg: 2, md: 1, sm: 1, xs: 1 }} sx={{ mb: 1 }} >
              {/* <Grid item xs={12} sm={6} md={6} lg={5} alignItems=""  >
                <Box >
                  <Grid display="flex">
                    <Grid className="" item lg={4}  >
                      <Box className={classes.headingIcon} sx={{ marginLeft: '3px' }}>
                        <Controls.Button
                          text="Add"
                          variant="text"
                          id="add-button"
                          aria-haspopup="true"
                          aria-controls="add-menu"
                          onClick={handleAddMenuHover}
                          startIcon={<AddSquareIcon />}
                          className={classes.button + " menu-btn"}
                          aria-expanded={openAddMenu ? 'true' : undefined}
                        />
                        <Menu
                          id="add-menu"
                          MenuListProps={{
                            'aria-labelledby': 'add-button',
                            'onMouseLeave': handleAddMenuClose
                          }}
                          PaperProps={{
                            style: {
                              minWidth: 150,
                            },
                          }}
                          anchorEl={addMenuEl}
                          open={openAddMenu}
                          onClose={handleAddMenuClose}
                          TransitionComponent={Fade}
                        >
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={e => addNewSheet()} >Sheet</MenuItem>
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={e => onOpenSidebar({ title: 'Filter' })}>Filter</MenuItem>
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={e => onOpenSidebar({ title: 'Visualize' })}>Reports</MenuItem>
                        </Menu>
                      </Box>

                    </Grid>
                    <Grid className="" item lg={4} >
                      <div className={classes.headingIcon}>
                        <Controls.Button className={classes.button + "  menu-btn"} text="Refresh" startIcon={<RefreshIcon />} variant="text"
                          onClick={handleDashboadResync} />
                      </div>
                    </Grid>
                    <Grid className="" item lg={4} >
                      <div className={classes.headingIcon}>
                        <Controls.Button className={classes.button + "  menu-btn"} text="More" startIcon={<MoreIcon />} variant="text"
                          id="more-button"
                          aria-controls="more-menu"
                          aria-haspopup="true"
                          aria-expanded={openMoreMenu ? 'true' : undefined}
                          onClick={handleMoreMenuHover}
                        />
                        <Menu
                          id="more-menu"
                          MenuListProps={{
                            'aria-labelledby': 'more-button',
                            'onMouseLeave': handleMoreMenuClose
                          }}
                          PaperProps={{
                            style: {
                              minWidth: 150,
                            },
                          }}
                          anchorEl={moreMenuEl}
                          open={openMoreMenu}
                          onClose={handleMoreMenuClose}
                          TransitionComponent={Fade}
                        >
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={e => handleSaveAsPopup(true)}>Copy</MenuItem>
                          {
                            (currentRole?.toLowerCase() === 'superadmin' || (
                              currentUserType && currentUserType?.exportAuth?.pdf)) &&
                            <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={handleDashboardExport}>Export</MenuItem>
                          }
                          <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={() => handleSelectDeleteDash('open')}  >Delete</MenuItem>
                          <MenuItem className={classes.menuDropdownItem + " menu-item"}  >
                            <FormGroup>
                              <FormControlLabel
                                className={"text-plain " + dashboardState?.tabDesign}
                                control={
                                  <Switch
                                    name='tabDesign'
                                    onChange={tabDesignChange}
                                    checked={(dashboardState?.tabDesign && dashboardState?.tabDesign === 'new') ? true : false}
                                  />
                                }
                                label="New Tab Design" />
                            </FormGroup>
                          </MenuItem>
                          <MenuItem className={classes.menuDropdownItem + " menu-item"}  >
                            <FormGroup>
                              <FormControlLabel
                                className={"text-plain "}
                                control={
                                  <Switch
                                    name='notification'
                                    onChange={notificationBannerChange}
                                    checked={dashboardState?.notificationBanner} />
                                }
                                label="Notification Banner"
                              />
                            </FormGroup>
                          </MenuItem>
                        </Menu>
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </Grid> */}
              <Box className="re-edit-header-options">
                <Box className="re-edit-header-option re-edit-header-copy-btn">
                    <CopyAsNewIcon /> <span>Copy as new</span>
                </Box>
                <Box className="re-edit-header-option re-edit-header-export-btn"  onClick={(e) => handleAddMenuHover(e)}>
                    <ExportIcon /> <span>Export</span> <DropdownIcon />
                </Box>

                
                <Menu
                    id="more-export-menu"
                    MenuListProps={{
                        'aria-labelledby': 'more-export-button',
                        //'onMouseLeave': () => setMoreExportMenuEl(null)
                    }}
                    classes={{
                        root: 'popover-exportmenu-report-header popover-menu'
                    }}
                    PaperProps={{
                        style: {
                            minWidth: 110,
                        },
                    }}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    anchorEl={addMenuEl}
                    open={openAddMenu}
                    onClose={handleAddMenuClose}
                    TransitionComponent={Fade}
                >
                    <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={handleDashboardExport}>PDF</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={handleDashboardExport} >CSV file</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item"} onClick={handleDashboardExport} >Excel file</MenuItem>
                </Menu>

                <Box className="re-edit-header-option">
                  <Controls.Button className={classes.headingButtonWrap + ' ' + "re-btn re-btn-outline"} 
                    onClick={handleDashboardPreview} text={"Preview"}
                  />
                </Box>
                <Box className="re-edit-header-option re-btn re-btn-primary">
                  <Controls.Button className={classes.headingButtonWrap + ' ' + "re-btn"}
                    onClick={onhandleSaveDashboard} disabled={onSaveLoader}
                    text={onSaveLoader ? (<CircularProgress color="white" size={22} />) : "Save"}
                  />
                </Box>

                {UrlParams?.id !== "new" ? (
                    <>

                      {
                        (currentRole?.toLowerCase() === 'superadmin' ||
                          (currentUserType && currentUserType?.publishDashboard !== false)) &&
                          <Box className="re-edit-header-option re-btn re-btn-primary">
                            <Controls.Button className={classes.headingButtonWrap + ' ' + "re-btn"} text="Publish" variant="contained"
                              onClick={handlePublishDashboard} />
                          </Box>
                      }
                    </>
                  ) : null}

            </Box>
              {/* <Grid item xs={12} sm={6} md={((UrlParams?.id !== "new") ? 6 : 4)} lg={((UrlParams?.id !== "new") ? 6 : 4)} justifyContent="flex-end"  >
                <Grid display="flex" className={classes.headerButtons}>
                  <Box className={classes.headingButton} display="flex">
                    <Controls.Button className={classes.headingButtonWrap + ' ' + "re-btn re-btn-outline"} 
                      onClick={handleDashboardPreview} text={"Preview"}
                    />
                  </Box>

                  <Box className={classes.headingButton} display="flex">
                    <Controls.Button className={classes.headingButtonWrap + ' ' + "re-btn"}
                      onClick={onhandleSaveDashboard} disabled={onSaveLoader}
                      text={onSaveLoader ? (<CircularProgress color="white" size={22} />) : "Save"}
                    />
                  </Box>

                  {UrlParams?.id !== "new" ? (
                    <>

                      {
                        (currentRole?.toLowerCase() === 'superadmin' ||
                          (currentUserType && currentUserType?.publishDashboard !== false)) &&
                        <Box className={classes.headingButton} display="flex" >
                          <Controls.Button className={classes.headingButtonWrap + ' ' + "report_form_ui_btn"} text="Publish" variant="contained"
                            onClick={handlePublishDashboard} />
                        </Box>
                      }
                      <Box className={classes.headingButtonLg} display="flex" >
                        <Controls.Button className={classes.headingButtonWrap + ' ' + "report_form_ui_btn"} text="New Dashboard" variant="contained"
                          href="/reportDashboard/new" target="_blank" startIcon={<AddIcon className="btn_icon_before" />} />
                      </Box>
                    </>
                  ) : null}
                </Grid>
              </Grid> */}

            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>


      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={confirmDeleteDialog}
        closeAfterTransition
      >
        <Fade in={confirmDeleteDialog}>
          <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
            <Box className="modal-content-simple">
              <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this dashboard ?`}</Typography>
              <Box className="modal-footer-simple">
                <Button onClick={() => handleSelectDeleteDash('cancel')} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                <Button onClick={submitDeleteDashboard} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
